"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const DyanmicTableHead_1 = __importDefault(require("@/components/DynamicTable/DyanmicTableHead"));
const style_1 = require("@/components/DynamicTable/DynamicTableRow/style");
const SimpleCell_1 = __importDefault(require("@/components/DynamicTable/Cells/SimpleCell"));
const DeletableCell_1 = __importDefault(require("@/components/DynamicTable/Cells/DeletableCell"));
const TableLoader_1 = __importDefault(require("@/components/TableLoader"));
const formatDate_1 = require("@/utilities/formatDate");
const constants_1 = require("./constants");
const ProductsDialogAlert_1 = __importDefault(require("../ProductsDialogAlert"));
const ProductTableTitleSection_1 = __importDefault(require("./ProductTableTitleSection"));
const style_2 = require("./style");
function ProductsTableView({ productRows, isLoading, onShowDeleteAlert, onNavigateToEdition, }) {
    return isLoading ? (react_1.default.createElement(TableLoader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ProductTableTitleSection_1.default, null),
        react_1.default.createElement(style_2.ScrollableTableContainer, null,
            react_1.default.createElement(Table_1.default, { stickyHeader: true, sx: { height: "fit-content" } },
                react_1.default.createElement(DyanmicTableHead_1.default, { tableHeadCells: constants_1.tableHeadCells }),
                react_1.default.createElement(TableBody_1.default, null,
                    productRows?.map((row, i) => {
                        const date = row?.updatedAt
                            ? (0, formatDate_1.formatDate)(new Date(row?.updatedAt))
                            : "";
                        const onDelete = () => {
                            onShowDeleteAlert(row, i);
                        };
                        const handleEditionPage = () => {
                            onNavigateToEdition(row?.id);
                        };
                        return (react_1.default.createElement(style_1.StyledTableRow, { key: i },
                            react_1.default.createElement(SimpleCell_1.default, { onClick: handleEditionPage, align: "left", variant: "body", key: row?.name }, row?.name),
                            react_1.default.createElement(SimpleCell_1.default, { onClick: handleEditionPage, variant: "body", align: "right", key: date }, date),
                            react_1.default.createElement(DeletableCell_1.default, { align: "left", onDelete: onDelete })));
                    }),
                    react_1.default.createElement(ProductsDialogAlert_1.default, null))))));
}
exports.default = ProductsTableView;
